import { Expose, Type } from 'class-transformer';
import { CategoryDto } from './categories.dto';
import { TagType } from '@coworkrz/cards/types';
import { ProductUnit } from '@coworkrz/products/types';
import { ReservationDto } from './reservations.dto';

export class SharedProductDto {
  @Expose()
  id: string;
  @Expose()
  name: string;
  @Expose()
  code: string;
  @Expose()
  externalRef: number | string;
  @Expose()
  category: CategoryDto;
  @Expose()
  image: string;
  @Expose()
  prices: SharedPriceDto[];
  @Expose()
  reservations: ReservationDto[];
  @Expose()
  @Type(() => SharedProductDto)
  childProducts?: SharedProductDto[];
}

export class SharedPriceDto {
  @Expose()
  id: string;
  @Expose()
  startDate: Date;
  @Expose()
  endDate?: Date;
  @Expose()
  amount: number;
  @Expose()
  tag?: TagType;
  @Expose()
  unit: ProductUnit;
  @Expose()
  isActive: boolean;
  isSubscription?: boolean;
  @Expose()
  product: SharedProductDto;
}
